import DynamicSort from './DynamicSort';

export default DynamicSort;
